// extracted by mini-css-extract-plugin
export default {"page":"VW-z","cartModal":"WW-z","checkout":"XW-z","placeholder":"YW-z","account":"ZW-z"};